var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFacebookChat)?_c('div',[_c('div',{attrs:{"id":"testFacebookChat"}}),_c('div',{attrs:{"id":"fb-root"}}),_c('div',{staticClass:"fb-customerchat",attrs:{"id":"fb-customer-chat","page_id":_vm.pageId,"attribution":_vm.attribution}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }